<template>
  <div
    class=""
  >
    <canvas
      id="c"
    />
  </div>
</template>

<script type="module">
import * as THREE from 'three';

export default {
  data() {
    return {
      fov: 75, // 相机视野范围
      aspect: 2, // 画布的宽高比 在默认情况下 canvas画布是300x150像素，所以宽高比为300/150或者说2
      near: 0.1, // 相机近平面
      far: 5, // 相机远平面

      boxWidth: 1,
      boxHeight: 1,
      boxDepth: 1,
    };
  },
  mounted() {
    this.main();
  },
  methods: {
    main() {
      const canvas = document.querySelector('#c');
      const renderer = new THREE.WebGLRenderer({antialias: true, canvas});
      const {fov, aspect, near, far} = this;
      const camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
      console.log(renderer, 'renderer 1', camera, 'camera 1');

      // 摄像机默认指向Z轴负方向，上方向朝向Y轴正方向。我们将会把立方体放置在坐标原点，所以我们需要往后移一下摄像机才能显示出物体
      camera.position.x = 0;
      camera.position.z = 3;
      camera.position.y = 0.8;

      // 然后我们创建一个场景(Scene)。
      const scene = new THREE.Scene();

      // 然后创建一个包含盒子信息的立方几何体(BoxGeometry)。几乎所有希望在three.js中显示的物体都需要一个包含了组成三维物体的顶点信息的几何体。
      const {boxWidth, boxHeight, boxDepth} = this;
      const geometry = new THREE.BoxGeometry(boxWidth, boxHeight, boxDepth);
      // 然后创建一个基本的材质并设置它的颜色. 颜色的值可以用css方式和十六进制来表示。
      // const material = new THREE.MeshBasicMaterial({color: 0x44aa88});
      const material = new THREE.MeshPhongMaterial({
        color: 0x44aa88, // 绿蓝色 受灯光影响的MeshPhongMaterial材质
      });
      // 再创建一个网格(Mesh)对象，它包含了 geometry(几何体 物体的形状) material(材质 如何绘制物体，光滑还是平整，什么颜色，什么贴图..)
      const cube = new THREE.Mesh(geometry, material);
      // 修改位置
      cube.position.x = -0.5;
      cube.position.y = 1.8;
      cube.position.z = -1.8;
      

      // 最后我们将网格添加到场景中。
      scene.add(cube);
      // 之后将场景和摄像机传递给渲染器来渲染出整个场景。
      renderer.render(scene, camera);

      function resizeRendererToDisplaySize(renderer) {
        const canvas = renderer.domElement;
        const width = canvas.clientWidth;
        const height = canvas.clientHeight;
        const needResize = canvas.width !== width || canvas.height !== height;
        if (needResize) {
          renderer.setSize(width, height, false);
        }
        return needResize;
      }

      // 立方体旋转
      function render(time) {
        time *= 0.001;  // 将时间单位变为秒


        // 注意如果我们的canvas大小被调整了那函数会返回true。我们可以利用 这个来检查是否有其他的东西应该更新。我们修改渲染循环 来使用我们的新函数
        if (resizeRendererToDisplaySize(renderer)) {
          const canvas = renderer.domElement;
          camera.aspect = canvas.clientWidth / canvas.clientHeight;
          camera.updateProjectionMatrix();
        }

        // 我们先解决拉伸的问题。为此我们要将相机的宽高比设置为canvas的宽高比。 我们可以通过canvas的clientWidth和clientHeight属性来实现。
        const canvas = renderer.domElement;
        camera.aspect = canvas.clientWidth / canvas.clientHeight;
        camera.updateProjectionMatrix();
      
        cube.rotation.x = time;
        cube.rotation.y = time;

        cubes.forEach((cube, ndx) => {
          const speed = 1 + ndx * .1;
          const rot = time * speed;
          cube.rotation.x = rot;
          cube.rotation.y = rot;
        });
      
        renderer.render(scene, camera);
      
        requestAnimationFrame(render);
      }
      requestAnimationFrame(render);

      // 灯光
      const color = 0xFFFFFF;
      const intensity = 3;
      const light = new THREE.DirectionalLight(color, intensity);
      light.position.set(-1, 2, 4); // 位置
      scene.add(light);

      function makeInstance(geometry, color, x) {
        const material = new THREE.MeshPhongMaterial({color});
      
        const cube = new THREE.Mesh(geometry, material);
        scene.add(cube);
      
        cube.position.x = x;
      
        return cube;
      }

      const cubes = [
        makeInstance(geometry, 0x44aa88,  0),
        makeInstance(geometry, 0x8844aa, -2),
        makeInstance(geometry, 0xaa8844,  2),
      ];
      scene.add(cubes);

    },
  }
}
</script>

<style scoped>
/* HTML中的body默认有5个像素的margin值所以设置margin为0来移除margin值。 设置html和body的高度为100%让他们充满整个窗口。不然的话他们的大小只会 和填充他们的内容一样。

然后我们让id=c的元素的尺寸是容器的100%这里是body标签。

最后我们设置它的display为block。canvas的display默认为 inline。行内元素的末尾会有空格。 通过设置canvas为块级元素就能消除这个空格。 */
html, body {
  margin: 0;
  height: 100%;
}
#c {
  width: 100%;
  height: 100%;
  display: block;
}
</style>